// Helpers for inbox duration triage flags on create and update.
import { DEFAULT_TASK_DURATION_MINS } from '@/config/constants';

/**
 * True when a task still needs inbox duration triage.
 * Legacy tasks without `requireTimeReview` fall back to the old 15-min heuristic.
 *
 * @param {{ duration?: number|null, requireTimeReview?: boolean }} task
 */
export function needsDurationReview(task) {
  if (task.requireTimeReview === false) return false;
  if (task.requireTimeReview === true) return true;
  return !task.duration || task.duration === DEFAULT_TASK_DURATION_MINS;
}

/**
 * @param {Record<string, unknown>} task
 * @param {{
 *   durationExplicitlyProvided?: boolean,
 *   requireTimeReviewExplicit?: boolean,
 * }} [options]
 */
export function withDurationReviewOnCreate(task, options = {}) {
  const {
    durationExplicitlyProvided = false,
    requireTimeReviewExplicit = false,
  } = options;
  const duration = task.duration ?? DEFAULT_TASK_DURATION_MINS;

  if (requireTimeReviewExplicit) {
    return { ...task, duration, requireTimeReview: task.requireTimeReview };
  }

  return {
    ...task,
    duration,
    requireTimeReview: durationExplicitlyProvided ? false : true,
  };
}

/**
 * @param {Record<string, unknown>|null|undefined} updates
 */
export function applyDurationReviewToUpdate(updates) {
  if (updates === null || updates === undefined) return updates;
  if (!Object.prototype.hasOwnProperty.call(updates, 'duration')) {
    return updates;
  }
  return { ...updates, requireTimeReview: false };
}
